import { LightningElement, api } from "lwc";

class headerAvatar extends LightningElement {
  @api imgSrc = "";
  @api percent = null;

  get d() {
    if (!this.percent) return "";
    let isLong = this.percent > 50 ? 1 : 0;
    let fill = 1 - this.percent / 100;
    let arcX = Math.cos(2 * Math.PI * fill);
    let arcY = Math.sin(2 * Math.PI * fill);
    return `M 1 0 A 1 1 0 ${isLong} 0 ${arcX} ${arcY} L 0 0`;
  }
}

export default headerAvatar;
